import React, { useEffect, useState } from "react";
// import '../LandingCostCalculator/landingcostcalculator.css';
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import landingCostCalculatorService from "../../../components/Services/landingCostCalculator.service";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { Col, Row } from "react-bootstrap";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const LccExcelUpload = () => {
  const [excelUploadValue, setExcelUploadValue] = useState(null);
  const [fileName, setFileName] = useState(null);
  const itemList = [
    "ID",
    "Region",
    "State/BANKING",
    "Voltage",
    "POC Losses %",
    "STU Losses %",
    "Distribution Losses",
    "POC Charges",
    "STU Charges",
    "Distribution Charges",
    "Additional Surcharge",
    "CSS (Industrial)",
    "CSS (Commercial)",
    "CSS (Energy Intensive)",
    "CSS (Discom)",
    "CSS (Other)",
    "Other Charges",
    "RPO-Solar %",
    "RPO-Non Solar %",
    "RPO-Non RE %",
  ];

  const handleProofOfPayment = (e) => {
    const fun = async (e) => {
      const fileList = e?.target?.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        let extension = file.name.split(".").pop();
        let fileSize = file.size / 1024 / 1024;
        let extList = ["xls", "xlsx"];
        if (fileSize < 100) {
          if (extList.includes(extension)) {
            let formData = new FormData();
            formData.append("file", file);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            landingCostCalculatorService
              .uploadLccExcelSheet(formData, config)
              .then((response) => {
                if (response?.data?.code === 200) {
                  setExcelUploadValue(response?.data?.data || "");
                  setFileName(fileList[0]?.name);
                  toast.success(response?.data?.message, toastProperties);
                } else if (response?.data?.code !== 200) {
                  setExcelUploadValue(response?.data?.data);
                  setFileName(fileList[0]?.name);
                }
              })
              .catch((error) => {
                console.error("Api call Error :", error);
              });
          } else {
            setExcelUploadValue("");
            toast.error("Only excel formats can be uploaded", toastProperties);
          }
        } else {
          toast.error("File Size Cannot Exceed 100mb", toastProperties);
          setExcelUploadValue("");
        }
      } else setExcelUploadValue("");
    };
    fun(e);
  };
  let dataArray = [];
  if (excelUploadValue) {
    dataArray = Object.entries(excelUploadValue);
  }
  return (
    <>
      <div className="container my-4">
        <div className="landingcost-card">
          <h6>Upload New file to change the Existing LCC Sheet</h6>
          <Row className="mb-3">
            <Col md={4}>
              <div className="file-input-wrapper">
                <input
                  type="file"
                  id="file-input2"
                  className="file-input"
                  onChange={(e) => handleProofOfPayment(e)}
                />
                <span>{fileName || "Upload Excel Sheet*"}</span>
                <label htmlFor="file-input2" className="file-input-label">
                  Upload
                </label>
              </div>
            </Col>
          </Row>
          <h6>
            Note: The new file for updating the existing LCC sheet should
            include the following columns in the specified order{" "}
          </h6>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="a dense table">
              <TableHead className="table-header">
                <TableRow>
                  {itemList?.map((item, i) => (
                    <TableCell
                      key={i}
                      sx={{ border: 1.5, borderColor: "whitesmoke" }}
                      align="center"
                    >
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          {excelUploadValue ? (
            <div>
              <h6>
                Below table contains errors in the uploaded sheet please correct
                them and upload again to change the existing LCC Sheet
              </h6>
              <table className="cus-table table-bordered my-documents-table">
                <thead className="table-header">
                  <tr>
                    <th>Cell Number</th>
                    <th>Cell Value</th>
                  </tr>
                </thead>
                <tbody>
                  {excelUploadValue?.map((item, index) => (
                    <tr key={index}>
                      <td>{item?.cell}</td>
                      <td>{item?.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default LccExcelUpload;
